import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface DigitalCardModel {
  name: string;
  surname: string;
  taxId: string;
  expirationDate: string;
}

@Component({
  selector: 'app-digital-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './digital-card.component.html',
  styleUrl: './digital-card.component.scss'
})
export class DigitalCardComponent {
  digitalCard: DigitalCardModel = {
  name: '',
  surname: '',
  taxId: '',
  expirationDate: ''
};

constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.digitalCard = {
        name: decodeURIComponent(params['name'] || ''),
        surname: decodeURIComponent(params['surname'] || ''),
        taxId: decodeURIComponent(params['taxId'] || ''),
        expirationDate: decodeURIComponent(params['expirationDate'] || '')
      };
    });
  }
}


